import { useRef, useEffect } from 'react';

function useSubscribeFieldEvent(form, subscribe, callback) {
  var pubSub = form.TI_FORM_INTERNAL.pubSub;
  var subscriberRef = useRef();
  useEffect(function () {
    if (!subscriberRef.current) {
      subscriberRef.current = pubSub === null || pubSub === void 0 ? void 0 : pubSub.subscribe(function (message) {
        if (message.target === subscribe) {
          var values = form.getFieldsValue(true);
          callback(values, message);
        }
      });
    }
    return function () {
      var _a;
      (_a = subscriberRef.current) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
  }, []);
}

export { useSubscribeFieldEvent as default };
